/**
 * A remote picture through Next's image optimizer at the size it's shown —
 * for plain <img> tags that can't use next/image (canvas-free animations,
 * tiny thumbnails). A 1254×1254 PNG shown at 42px cost visitors 3.6 MB
 * (PageSpeed 2026-10-31). Width must be one of Next's default image widths.
 */
export type OptimizedWidth = 64 | 96 | 128 | 256 | 384;

export function optimizedImage(src: string | undefined, width: OptimizedWidth = 96, quality = 70): string {
  if (!src || !/^https?:\/\//i.test(src)) return src || '';
  return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality}`;
}
